module.exports = __webpack_public_path__ + "static/taps2-b690e188699a5b8b76e02c1f8d3d00e1.png";